/** @module Router/list */
/**
 * list of name for better redirect routing
 * */
// forum route
export const home = '/'
export const homeName = '/'
export const about_us = '/about-us'
export const contact_us = '/contact-us'
export const faq = '/faq'
export const mag = '/mag/'
export const policies = '/terms'
export const start_teaching = '/start-teaching'
export const start_teaching_tracking = '/start-teaching/tracking'
export const academy = 'https://academy.ostadbank.com/'
export const tutor_package_list = 'tutor-package-list'
export const tutor_package_list_search_patch = '/tutor-package-list'
export const admin_panel = '/Admin/Panel'
export const dashboard_teacher = '/Dashboard'
export const login = '/auth/login'
export const loginName = 'auth-login'
export const logout = '/auth/logout'
export const login_by_otp = 'auth-confirm-code-password'
export const otp = 'auth-confirm-code'
export const password = 'auth-password'
export const set_password = 'auth-set-password'
export const foreget_password = 'auth-forget-password'
export const change_password = 'auth-change-password'
export const foreget_password_otp = 'auth-confirm-code-forget-password'
export const tutor_profile = 'tutor-name'
export const tutor_profile_link = 'tutor'
export const teacher_list = 'tutor-list'
export const best_teacher_list = 'best-tutor-list'
export const teacher_dashboard = '/Dashboard'
export const dashboard = '/profile/dashboard'
export const dashboard_name = 'profile-dashboard'
export const view_profile_dashboard = '/profile/dashboard'
export const dashboard_wallet = '/profile/dashboard/wallet'
export const dashboard_my_requests = '/profile/dashboard/my-requests'
export const view_teacher_requests_list = '/profile/dashboard'
export const teacher_list_link = 'tutor-list'
export const schools_list = 'list/tehran'
export const tutor_package_list_link = 'tutor-package-list'
export const dashboard_loyalty = '/profile/dashboard/loyalty-club'
export const teacher_request_tracking = 'tutor-request-tracking-id'
export const tracking_request_success = 'tutor-request-tracking-id-success'
export const dashboard_my_classes = 'profile-dashboard-my-classes'
export const dashboard_my_classes_detail = 'profile-dashboard-my-classes-id'
export const dashboard_my_classes_deposit = 'profile-dashboard-my-classes-id-session-sessionsId-deposit'
export const dashboard_my_classes_classbox_detail_session_box_details_modal = 'profile-dashboard-my-classes-classbox-detail-session-box-modal'
export const dashboard_my_classes_bill = 'profile-dashboard-my-classes-bill-defualt'
export const dashboard_my_classes_bill_with_wallet = 'profile-dashboard-my-classes-bill-with-wallet'
export const dashboard_my_classes_bill_error_1 = 'profile-dashboard-my-classes-bill-error-1'
export const dashboard_my_classes_bill_error_2 = 'profile-dashboard-my-classes-bill-error-2'
export const dashboard_my_classes_bill_payed = 'profile-dashboard-my-classes-bill-payed'
export const dashboard_my_classes_survey = 'profile-dashboard-my-classes-id-survey'
export const dashboard_my_classes_teacher_day = 'profile-dashboard-my-classes-id-teacher-day'
export const dashboard_my_classes_faq = 'profile-dashboard-my-classes-id-faq'
export const dashboard_my_classes_faq_slug = 'profile-dashboard-my-classes-id-faq-slug'
export const dashboard_my_classes_purchase_package = 'profile-dashboard-my-classes-id-purchase-discount-pack'
export const dashboard_discounts = 'profile-dashboard-discounts'
export const dashboard_loyalty_id = 'profile-dashboard-loyalty-club-id'
export const dashboard_loyalty_help = 'profile-dashboard-loyalty-club-help'
export const dashboard_support = 'profile-dashboard-support'
export const dashboard_ticket = 'profile-dashboard-ticket'
export const dashboard_ticket_id = 'profile-dashboard-ticket-id'
export const dashboard_tutor_package_name = 'profile-dashboard-tutor-package'
export const dashboard_tutor_package_session = 'profile-dashboard-tutor-package-package_id-session-session_id'
export const dashboard_tutor_package_id_name = 'profile-dashboard-tutor-package-package_id'
export const dashboard_transactions = 'profile-dashboard-transaction'
export const dashboard_my_requests_name = 'profile-dashboard-my-requests'
export const dashboard_wallet_name = 'profile-dashboard-wallet'
export const dashboard_email_verification = 'profile-dashboard-email-verification'
export const dashboard_email_verification_code = 'profile-dashboard-email-verification-code'
export const getTeacherListLink = (config, route) => {
  return config.base_url_website + '/' + route
}
export const getTutorProfileLink = (config, name) => {
  return config.base_url_website + '/' + tutor_profile_link + '/' + name
}
export const teacher_list_absolute = (config, params) => {
  return config.base_url_website + '/' + teacher_list + '/' + params
}
export const absolute_link = (config, link) => {
  return config.base_url_website + '/' + link.replace(/^\/|\/$/g, '')
}
export const sub_absolute_link = (baseUrl, link) => {
  return baseUrl + '/' + link.replace(/^\/|\/$/g, '')
}
// design-system routes
// TODO find solution for this problem
export const dashboard_tutor_package = '/profile/dashboard/tutor-package'
export const dashboard_tutor_package_id = '/profile/dashboard/tutor-package/id'
export const invoice = '/invoice/uuid'
export const dashboard_link = '/dashboard'
export const tutor_package_details_link = 'tutor-package'
